import React, { useContext, useEffect, useState } from "react";
import api from "services/api";
import MerchantCard from "components/merchants/MerchantCard";
import InfoCard from "components/common/InfoCard";
import { AccessibilityContext } from "contexts/AccessibilityContext";
import styles from "styles/modules/CardList.module.css";
import { faStore } from "@fortawesome/free-solid-svg-icons";
import { useSubSite } from 'contexts/SubSiteContext';
import Spinner from "components/common/Spinner";

const MerchantList = () => {
  const [merchants, setMerchants] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getAccessibilityVariant } = useContext(AccessibilityContext);
  const [accessibilityVariant, setAccessibilityVariant] = useState(
    getAccessibilityVariant()
  );
  const { subSiteSlug } = useSubSite();

  const merchantsURL = `/${subSiteSlug}/commercants`;

  useEffect(() => {
    const fetchMerchants = async () => {
      try {
        const response = await api.get(`/subsites/${subSiteSlug}/merchants`);
        setMerchants(response.data.slice(0, 3)); // Limiter à 3 commerçants
      } catch (error) {
        console.error("Erreur lors de la récupération des commerçants:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMerchants();
  }, [subSiteSlug]);

  useEffect(
    () => {
      setAccessibilityVariant(getAccessibilityVariant());
    },
    [getAccessibilityVariant]
  );

  if (loading) {
    return <div><Spinner /></div>;
  }

  // Ne rien afficher s'il n'y a pas de commerçants
  if (merchants.length === 0) {
    return null;
  }

  return (
    <section className="global-section">
      <div className="global-container">
        <h2>Nos Commerçants</h2>
        <ul className={`list--none ${styles.grid}`}>
          {merchants.map(merchant =>
            <MerchantCard
              key={merchant.id}
              merchant={merchant}
            />
          )}
          <InfoCard
            icon={faStore}
            title="Découvrez tous nos commerçants !"
            text="Explorez l'annuaire complet des commerces de la Ville de Noël."
            linkTo={merchantsURL}
            buttonText="Voir tous les commerçants"
            categorySlug="merchants"
            accessibilityVariant={accessibilityVariant}
          />
        </ul>
      </div>
    </section>
  );
};

export default MerchantList;






